import { getActionTypes } from '../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('engineScheduleManagement')([
  'SET_LOADER',
  'LOAD_ENGINE_SCHEDULES',
  'UPSERT_ENGINE_SCHEDULE',
  'DELETE_ENGINE_SCHEDULE',
  'SET_FORM_LOADER',
]);

export function loadEngineSchedule(engineSchedules) {
  return { type: types.LOAD_ENGINE_SCHEDULES, engineSchedules };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setFormLoader(loader) {
  return { type: types.SET_FORM_LOADER, loader };
}

export function upsertEngineSchedule(engineSchedule) {
  return { type: types.UPSERT_ENGINE_SCHEDULE, engineSchedule };
}

export function deleteEngineSchedule(engineSchedule) {
  return { type: types.DELETE_ENGINE_SCHEDULE, engineScheduleId: engineSchedule.id };
}

export default function engineScheduleReducer(
  state = { isEngineSchedulePageLoading: true, engineSchedules: [], isEngineScheduleFormLoading: false },
  action
) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isEngineSchedulePageLoading: action.loader };
    }
    case types.SET_FORM_LOADER: {
      return { ...state, isEngineScheduleFormLoading: action.loader };
    }
    case types.LOAD_ENGINE_SCHEDULES: {
      return { ...state, engineSchedules: action.engineSchedules };
    }
    case types.DELETE_ENGINE_SCHEDULE: {
      return {
        ...state,
        engineSchedules: state.engineSchedules.filter(
          ({ id: engineScheduleId }) => engineScheduleId !== action.engineScheduleId
        ),
      };
    }
    case types.UPSERT_ENGINE_SCHEDULE: {
      const { engineSchedule } = action;
      return {
        ...state,
        engineSchedules: [
          ...state.engineSchedules.filter(({ id: engineScheduleId }) => engineScheduleId !== engineSchedule.id),
          engineSchedule,
        ],
      };
    }
    default:
      return state;
  }
}
